export default "__VITE_ASSET__YdNaWF3C__"